import { Component, Input, ContentChild, TemplateRef } from '@angular/core';
import {Params} from "@angular/router";

@Component({
    selector: 'app-nav-tab',
    templateUrl: './nav-tab.component.html',
    standalone: false
})
export class NavTabComponent {
  @Input() title: string | undefined;
  @Input() itemId: number | undefined;
  @Input() isChecked: boolean = false;
  @Input() showIndicator: boolean = false;
  @Input() route: string | undefined;
  @Input() queryParams: Params | undefined;
  @ContentChild(TemplateRef, { static: true }) content!: TemplateRef<any>;
}